import axios from 'axios';
import { UserSelection, DispenseTransaction, CreateTransactionResponse } from '../types/DrinkTypes';
import { demoDrinksData } from '../data/demoData';

// Create an axios instance with default configurations
const axiosInstance = axios.create({
  withCredentials: false, // Do not send cookies with requests
});

const isDemoMode = process.env.REACT_APP_DEMO_MODE === 'true';

export const fetchAllDrinks = async () => {
  if (isDemoMode) {
    console.log('DEMO MODE: Dummifying fetchAllDrinks');
    return Promise.resolve(demoDrinksData);
  }
  try {
    const response = await axiosInstance.get("/api/refill/drinks/"); // handled either by the proxy in package.json or the nginx reverse proxy

    console.log('fetchAllDrinks response:', response);
    return response.data;

  } catch (error) {
    throw error;
  }
};

export const postDrinkSelection = async (selection: UserSelection): Promise<CreateTransactionResponse> => {
  if (isDemoMode) {
    console.log('DEMO MODE: Dummifying postDrinkSelection', selection);
    const drink = demoDrinksData.drinks.find(d => d.id === selection.drink_id);
    const payment_required = drink ? parseFloat(drink.price) > 0 : true;
    return Promise.resolve({ transaction_id: 'demo-transaction-123', payment_required });
  }
  try {
    const response = await axiosInstance.post("/api/refill/drinks/select/", selection);

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const cancelCurrentDispensing = async (transaction: DispenseTransaction) => {
  if (isDemoMode) {
    console.log('DEMO MODE: Dummifying cancelCurrentDispensing', transaction);
    return Promise.resolve({ status: 'cancelled_in_demo' });
  }
  try {
    const response = await axiosInstance.post("/api/refill/dispense/cancel/", transaction);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const turnOnBpLed = async () => {
  if (isDemoMode) {
    console.log('DEMO MODE: Dummifying turnOnBpLed');
    return Promise.resolve({ status: 'on_in_demo' });
  }
  try {
    const response = await axiosInstance.post("/api/refill/control-bp-led/", { command: 'on' });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const turnOffBpLed = async () => {
  if (isDemoMode) {
    console.log('DEMO MODE: Dummifying turnOffBpLed');
    return Promise.resolve({ status: 'off_in_demo' });
  }
  try {
    const response = await axiosInstance.post("/api/refill/control-bp-led/", { command: 'off' });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const sendRecapOnDemand = async (force_send_params?: { start_date?: string; end_date?: string }) => {
  if (isDemoMode) {
    console.log('DEMO MODE: Dummifying sendRecapOnDemand', force_send_params);
    return Promise.resolve({ status: 'recap_sent_in_demo' });
  }
  try {
    const response = await axios.post("/api/refill/send-recap/", { force_send_params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

